var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiAtUri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.61351 0 0 .61351 8.6041 7.2654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.518 12.626c0 1.0946 0.88736 1.982 1.982 1.982s1.982-0.88736 1.982-1.982-0.88736-1.982-1.982-1.982-1.982 0.88736-1.982 1.982",
    strokeWidth: 0.79279,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.518 18.176c0 1.0946 0.88736 1.982 1.982 1.982s1.982-0.88736 1.982-1.982c0-1.0946-0.88736-1.982-1.982-1.982s-1.982 0.88736-1.982 1.982",
    strokeWidth: 0.79279,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.368 8h-2.3682l-4 16h2.3682",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.368 24h-2.3682l4-16h2.3682",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.16 2.0104c-2.3338 0-4.329 0.84858-5.9839 2.5034-1.6548 1.6548-2.5034 3.6501-2.5034 5.9839 0 2.3338 0.84858 4.3276 2.5034 5.9824 1.6548 1.6548 3.6501 2.5034 5.9839 2.5034h0.02637c-0.0416-0.17964-0.06592-0.36581-0.06592-0.5581 0-0.41087 0.10185-0.79877 0.27978-1.1396h-0.24024c-1.8585 0-3.4551-0.65281-4.7959-1.9937-1.3408-1.3408-1.9937-2.9359-1.9937-4.7944 0-1.8585 0.65281-3.4551 1.9937-4.7959 1.3408-1.3408 2.9374-1.9937 4.7959-1.9937s3.4536 0.65281 4.7944 1.9937c1.3408 1.3408 1.9937 2.9374 1.9937 4.7959v0.48779h1.6978v-0.48779c0-2.3337-0.84858-4.329-2.5034-5.9839-1.6548-1.6548-3.6487-2.5034-5.9824-2.5034zm0 4.2437c-1.1626 0-2.1642 0.42457-3.0044 1.2393-0.81469 0.84015-1.2393 1.8418-1.2393 3.0044 0 1.1711 0.42457 2.1642 1.2393 3.0044 0.83405 0.80878 1.8276 1.2302 2.9795 1.2363 0.1327-1.2394 1.182-2.2061 2.4565-2.2061 1.2531 0 2.2858 0.93513 2.4463 2.1445 0.14454 0.0284 0.29364 0.04441 0.44678 0.05273l0.42774-1.7095c-0.07617 0.01437-0.15501 0.02344-0.2373 0.02344-0.33097 0-0.62724-0.13682-0.88184-0.3999-0.25459-0.26307-0.39111-0.56758-0.39111-0.91552v-1.2305c0-1.1626-0.4231-2.1642-1.2378-3.0044-0.84015-0.81469-1.8333-1.2393-3.0044-1.2393zm0 1.6978c0.6874 0 1.2724 0.2537 1.79 0.75439 0.5007 0.51767 0.75586 1.1041 0.75586 1.7915 0 0.6874-0.25516 1.2724-0.75586 1.79-0.51767 0.5007-1.1026 0.75586-1.79 0.75586-0.6874 0-1.2738-0.25516-1.7915-0.75586-0.5007-0.51767-0.75439-1.1026-0.75439-1.79 0-0.68739 0.2537-1.2738 0.75439-1.7915 0.51767-0.5007 1.1041-0.75439 1.7915-0.75439z",
    strokeWidth: 0.84864,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiAtUri);
export default __webpack_public_path__ + "static/media/MdiAtUri.8c4c7d620ed76dea8dff0af8cc719a5e.svg";
export { ForwardRef as ReactComponent };